export default __webpack_public_path__ + "static/media/106_mobile.aba09823.jpg";